import { GlobalService } from 'app/services/global.service';
import { ConfigurationService } from './../../modules/configuration/configuration.service';
import { Component, Input, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-view-modal',
  templateUrl: './view-modal.component.html',
  styleUrls: ['./view-modal.component.css']
})
export class ViewModalComponent implements OnInit {
  @Input() confirmValues: any;
  datalist = [];
  id = "";
  refundInfo:any;
  loader = false;
 
  constructor(
    public dialogRef : NgbActiveModal,
    public configService : ConfigurationService,
    public global : GlobalService
    ) { }

  ngOnInit(): void {
    this.refundInfo = this.confirmValues.data
  }
  // getRefundDetails(id){
  //   this.loader = true;
  //   this.configService.getRefundData(id).then((data)=>{
  //     this.refundInfo = data["Data"];
  //     this.loader = false;
  //   }).catch(err=>{
  //     this.loader = false;
  //     this.global.failureErrorModal(err);
  //   })
  // }
 
  close() {
    this.dialogRef.close({ success: false })
  }
}
